
import AppModal from '../AppModal'
import DayPassModal from './DayPassModal'

export default {
  name: 'MusicLimitReachedModal',
  components: { DayPassModal, AppModal },
  data () {
    return {
      showDayPassModal: false,
      icons: {
        a: 'fa-headphones',
        b: 'fa-music',
        c: 'fa-clock',
        d: 'fa-music'
      }
    }
  },
  computed: {
    modalType () {
      if (typeof this.$store.state.jukebox.freeTimeReachedModal === 'string') {
        return this.$store.state.jukebox.freeTimeReachedModal
      }

      return 'music_limit'
    },
    modalFeatures () {
      if (this.modalType === 'music_limit') {
        return ['a', 'b', 'c']
      }

      return ['a', 'd', 'c']
    },
    isOpen: {
      set (newValue) {
        this.$store.commit('jukebox/UPDATE_FREE_TIME_REACHED_MODAL', newValue)
      },
      get () {
        return this.$store.state.jukebox.freeTimeReachedModal
      }
    }
  },
  methods: {
    close () {
      this.isOpen = false
    }
  }
}
